// Web shim for @react-native-community/checkbox
// The native package doesn't export properly for web builds
// This provides a no-op export since we use native HTML checkbox on web anyway

import React from 'react';
import {View} from 'react-native';

// Placeholder component - on web we use native HTML input[type="checkbox"] instead
const CheckBox = props => {
  return React.createElement(View, props);
};

export default CheckBox;
